/**
 * UI-маппинг классов ситуации S0–S4 для уведомлений врача.
 * Порог создания алерта на бэкенде — min_alert_class (по умолчанию S3).
 */
export const SITUATION_CLASS_UI = {
    S0: { label: "Стабильно", severity: 0, accent: "neutral" },
    S1: { label: "Наблюдение", severity: 1, accent: "info" },
    S2: { label: "Умеренный риск", severity: 2, accent: "warning" },
    S3: { label: "Высокий риск", severity: 3, accent: "orange" },
    S4: { label: "Нужно внимание", severity: 4, accent: "danger" },
};

/** Приоритет для сортировки и выбора «главного» баннера */
export function getSituationSeverity(situationClass) {
    return SITUATION_CLASS_UI[situationClass]?.severity ?? 0;
}

export function getSituationLabel(situationClass) {
    return SITUATION_CLASS_UI[situationClass]?.label ?? situationClass;
}
